<template>
    <div>
        <h2>{{translate('integrate_title', integration.name)}}</h2>
         <p>
            {{translate('institute_text', integration.name)}}
        </p>
        <a :href="'/'+ language + '/integrations/contact/' + integration.id" class="btn btn-primary mt-6">{{translate('btn_contact')}}</a>
    </div>
</template>

<script lang="ts">
    import {defineComponent} from 'vue';
    import { SoftwarePartner } from '../../../types/dto/SoftwarePartner';
    import {Language} from "../../../types/dto/Language";

    export default defineComponent({
        name: 'integration_institute',
        props: {
            integration: Object as () => SoftwarePartner,
            language: String as () => Language
        }
    })
</script>
